import { Button, type ButtonProps } from '@mantine/core';
import type { FormLike } from '../../../hooks/useMultiForm';

export const Form_ResetButton = ({
    form: {
        reset,
        formState: { isDirty, isSubmitting },
    },
    onClick,
    ...props
}: Omit<ButtonProps, 'color' | 'disabled'> & {
    form: FormLike;
    onClick?: () => void;
}) => {
    return (
        <Button
            color="gray"
            onClick={() => {
                onClick?.();
                reset();
            }}
            disabled={!isDirty || isSubmitting}
            {...props}
        />
    );
};
